import { REP_V2 } from "../../../Data/typeDirs";
import { genId } from "../../../utils";

const createReportTemplateSchema = {
  _id: genId(),
  name: 'createReportTemplateSchema',
  content: [
    {
      name: 'nameContainer',
      type: 'Container',
      displaySettings: { as: 'Container' },
      children: [
        {
          name: 'name',
          type: 'text',
          label: 'Template Name',
        },
        {
          name: 'buildingType',
          type: 'text',
          label: 'Building Type'
        },
        {
          name: 'description',
          type: 'text',
          label: 'Description',
          displaySettings: {as:'textarea'}
        }
      ],
    }, {
      name: 'reportContainer',
      type: 'Container',
      displaySettings: { as: 'Container' },
      children: [
        {
          name: REP_V2,
          type: 'dropdown',
          label: 'Report to Template',
          source: [REP_V2]
        }
      ]
    }
  ]
}

export { createReportTemplateSchema }